import { create } from 'zustand';
import { api } from '../lib/api';

export interface AuthUser {
  id: string;
  username: string;
  role: 'admin' | 'user';
  avatarUrl?: string | null;
  mustChangePassword?: boolean;
  createdAt?: string;
  lastLoginAt: string | null;
}

interface AuthState {
  user: AuthUser | null;
  loading: boolean;
  init: () => Promise<void>;
  login: (username: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  loading: true,
  async init() {
    try {
      const r = await api.get<{ user: AuthUser | null }>('/api/auth/me');
      set({ user: r.user, loading: false });
    } catch {
      set({ user: null, loading: false });
    }
  },
  async login(username, password) {
    const r = await api.post<{ user: AuthUser }>('/api/auth/login', { username, password });
    set({ user: r.user });
  },
  async logout() {
    await api.post('/api/auth/logout');
    set({ user: null });
  },
}));
